import { apiLink } from '../../constants/env';
import axiosInstance, { AxiosAuth } from '../AxiosInstance';


const apiGrupo = {
    fetchApi: async () => {
        const URL = `/api/grupo`;
        return await AxiosAuth.get(URL)
            .then((res) => res)
            .catch(error => {
                console.error('Erro ao buscar os dados:', error);
                throw new Error(error);
            })
    },
    getById: async (id) => {
        const URL = `/api/grupo` + id;
        return await AxiosAuth.get(URL)
            .then((res) => res)
            .catch(error => {
                console.error('Erro ao buscar os dados:', error);
                throw new Error();

            })
    },
    pagination: async (page, pageSize = 10) => {
        const URL = `/api/grupo/paged?page=${page}&pageSize=${pageSize}`;
        return await AxiosAuth.get(URL)
            .then((res) => res)
            .catch(error => {
                console.error('Erro ao buscar os dados:', error);
                throw new Error();

            })
    },
    postApi: async (grupo) => {
        const URL = `/api/grupo`;
        return await AxiosAuth.post(URL, grupo)
            .then((res) => res)
            .catch(error => {
                console.error('Erro ao buscar os dados:', error);
                throw new Error();

            })
    },
    deleteApi: async (id) => {
        const URL = `/api/grupo/status/${id}`;
        return await AxiosAuth.get(URL)
            .then((res) => res)
            .catch(error => {
                console.error('Erro ao buscar os dados:', error);
                throw new Error();

            })
    },
    putApi: async (id, grupo) => {
        const URL = `/api/grupo/${id}`;
        return await AxiosAuth.put(URL, grupo)
            .then((res) => res)
            .catch(error => {
                console.error('Erro ao buscar os dados:', error);
                throw new Error();

            })
    }

}

export default apiGrupo;

